import {Navigate, Route, Routes} from "react-router-dom";
import {RequireAdminSession} from "./components/RequireAdminSession";
import {DashboardPage} from "./pages/DashboardPage";
import {LoginPage} from "./pages/LoginPage";
import {TenantsPage} from "./pages/TenantsPage";
import {CreateTenantPage} from "./pages/CreateTenantPage";
import {TenantDetailPage} from "./pages/TenantDetailPage";
import {FeatureFlagsPage} from "./pages/FeatureFlagsPage";
import {PlansPage} from "./pages/PlansPage";
import {PromotionsPage} from "./pages/PromotionsPage";
import {SupportPage} from "./pages/SupportPage";
import {InvoicesPage} from "./pages/InvoicesPage";
import {SentEmailsPage} from "./pages/SentEmailsPage";
import {SettingsPage} from "./pages/SettingsPage";
import {DeploymentsPage} from "./pages/DeploymentsPage";
import {PipelinePage} from "./pages/PipelinePage";
import {TenantManagementLayout} from "./layouts/TenantManagementLayout";

export function App() {
    return (
            <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route
                        path="/"
                        element={
                            <RequireAdminSession>
                                <TenantManagementLayout />
                            </RequireAdminSession>
                        }
                >
                    <Route index element={<DashboardPage />} />
                    <Route path="tenants" element={<TenantsPage />} />
                    <Route path="tenants/new" element={<CreateTenantPage />} />
                    <Route path="tenants/:tenantId" element={<TenantDetailPage />} />
                    <Route path="deployments" element={<DeploymentsPage />} />
                    <Route path="pipeline" element={<PipelinePage />} />
                    <Route path="feature-flags" element={<FeatureFlagsPage />} />
                    <Route path="invoices" element={<InvoicesPage />} />
                    <Route path="sent-emails" element={<SentEmailsPage />} />
                    <Route path="plans" element={<PlansPage />} />
                    <Route path="promos" element={<PromotionsPage />} />
                    <Route path="support" element={<SupportPage />} />
                    <Route path="settings" element={<SettingsPage />} />
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
    );
}
